import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden bg-ocean text-sand"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10 sm:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <h3 className="font-display text-3xl tracking-tight text-sand">
              Blessed <span className="italic text-terracotta">Algarve</span>
            </h3>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-sand/70">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <p className="overline text-terracotta/90">Contact</p>
            <a
              href="mailto:blessedalgarve@gmail.com"
              data-testid="footer-email"
              className="mt-4 inline-flex items-center gap-2 text-sm text-sand/85 hover:text-terracotta"
            >
              <Mail className="h-4 w-4" strokeWidth={1.4} />
              blessedalgarve@gmail.com
            </a>
            <p className="mt-3 text-sm text-sand/60">Algarve · Portugal</p>
            <p className="mt-1 text-sm text-sand/60">www.blessedalgarve.com</p>
          </div>

          <div>
            <p className="overline text-terracotta/90">Follow</p>
            <div className="mt-4 flex flex-col gap-3">
              <a
                href="https://www.instagram.com/blessed_photography_pt/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-2 text-sm text-sand/85 transition-colors hover:text-terracotta"
              >
                <Instagram className="h-4 w-4" strokeWidth={1.4} />
                @blessed_photography_pt
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61567857170381"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="inline-flex items-center gap-2 text-sm text-sand/85 transition-colors hover:text-terracotta"
              >
                <Facebook className="h-4 w-4" strokeWidth={1.4} />
                Blessed Algarve
              </a>
            </div>
          </div>
        </div>

        <div className="hairline mt-16" />
        <div className="mt-6 flex flex-col items-center justify-between gap-2 text-[11px] uppercase tracking-[0.22em] text-sand/50 sm:flex-row">
          <span>© {year} Blessed Algarve — {t("footer.rights")}</span>
          <span>Crafted with love on the Atlantic coast</span>
        </div>
      </div>
    </footer>
  );
}
